import axios from "axios";
import { checkUrl } from "../../../components/Data";
import { getCurrentHost, isHazteoirHost } from "../../../utils/hostRouting";

export const HAZTEOIR_UNSUBSCRIBE_LOCALE = "ES_HO";

export function interpolate(template, vars) {
  return template?.replace(/{{\s*([^}]+)\s*}}/g, (_, key) =>
    key in vars ? String(vars[key]) : ""
  );
}

export const getMessageType = (msgTypeParam, candidateHost = getCurrentHost()) => {
  if (isHazteoirHost(candidateHost)) {
    return HAZTEOIR_UNSUBSCRIBE_LOCALE;
  }

  const _params = new URLSearchParams(msgTypeParam);
  const message_type = _params.get("msg_type");
  return mapMessageType(message_type);
};

export function mapMessageType(message_type) {
  const msgTypesMap = {
    4954: "HU_HU",
    4955: "IT_IT",
    4956: "PL_PL",
    4957: "SK_SK",
    4958: "TL_PH",
    4959: "ES_AR",
    4960: "ES_MX",
    4961: "ES_ROW",
    4962: "ES_US",
    4963: "PT_BR",
    4964: "PT_PT",
    4965: "EN_AF",
    4966: "EN_AU",
    4967: "EN_CA",
    4968: "EN_GB",
    4969: "EN_IE",
    4970: "EN_ROW",
    4971: "EN_US",
    4972: "DE_AT",
    4973: "DE_CH",
    4974: "DE_DE",
    4975: "FR_CA",
    4976: "FR_FR",
    4977: "HR_HR",
    4978: "NL_NL",
    4979: "VLS_BE",
    4952: "ES_HO",
  };
  return msgTypesMap[message_type] || "EN_ROW";
}

export function getCountryCodeByMessageType(message_type) {
  return mapMessageType(Number(message_type));
}

export function isHazteoirMessageType(messageType) {
  return messageType === HAZTEOIR_UNSUBSCRIBE_LOCALE
    || String(messageType) === "4952";
}

export function hoHandler(messageType) {
  if (isHazteoirMessageType(messageType))
    return "https://ve-sign.citizengo.org/static/media/logo_ho.c00146bd8d1bc489f24a.webp";
  return "https://ve-sign.citizengo.org/static/media/cgo-new-mobile-logo.bf9346555bc4eda23cd0.webp";
}

export function checkHO_handler(messageType) {
  return isHazteoirMessageType(messageType);
}

export async function scrambleEmail(dr) {
  try {
    const res = await axios.post(`${checkUrl()}/api/v1/marketo/unsubscription/scramble-email`, {
      dr_tok: dr
    });
    return res.data.email;
  } catch (e) {
    console.log(e);
  }
}

export async function handleUnsubscription(dr, msg_type, campaign_id, reason, redirectToConfirmation, endpoint, showSnackbar, errorMessage) {
  try {
    const res = await axios.post(`${checkUrl()}/${endpoint}`, {
      dr: dr,
      msg_type: msg_type,
      campaign_id: campaign_id,
      reason: reason || "no reason provided"
    });

    const { success, error } = res.data;

    if (!success) {
      showSnackbar(error);
      return;
    }

    redirectToConfirmation();
  } catch (e) {   
    console.log(e);
    showSnackbar(errorMessage);
  }
}
